// extracted by mini-css-extract-plugin
module.exports =  {"alert":"ewTUzEetZlAN0Sv4L5tS"};